export default __webpack_public_path__ + "65a2fb6d9aaa164b41a039302093995b.ttf";